{
  "Accessibility menu": "Hozzáférhetőségi menü",
  "Close": "Bezárás",
  "Content adjustments": "Tartalom beállításai",
  "Navigation adjustments": "Navigáció beállításai",
  "Align Left": "Balra igazítás",
  "Adjust Font Size": "Betűméret beállítása",
  "Highlight Title": "Cím kiemelése",
  "Highlight Links": "Linkek kiemelése",
  "Readable Font": "Olvasható betűtípus",
  "Colour adjustments": "Színbeállítások",
  "Dark Contrast": "Sötét kontraszt",
  "Light Contrast": "Világos kontraszt",
  "High Contrast": "Magas kontraszt",
  "High Saturation": "Magas telítettség",
  "Low Saturation": "Alacsony telítettség",
  "Monochrome": "Monokróm",
  "Tools": "Eszközök",
  "Reading Guide": "Olvasási útmutató",
  "Big Cursor": "Nagy kurzor",
  "Increase Font Size": "Betűméret növelése",
  "Decrease Font Size": "Betűméret csökkentése",
  "Letter Spacing": "Betűtávolság",
  "Line Height": "Sor magasság",
  "Font Weight": "Betűtípus vastagsága",
  "Dyslexia Font": "Dyslexia betűtípus",
  "Language": "Nyelv",
  "Accessibility widget": "Hozzáférhetőségi menü megnyitása",
  "Accessibility Profiles": "Hozzáférhetőségi profilok",
  "Cognitive Disability": "Kognitív fogyatékosság",
  "Seizure Safe": "Epilepsziás rohamokra biztonságos",
  "Accessibility statement": "Hozzáférhetőségi nyilatkozat",
  "ADHD": "ADHD",
  "Low Vision": "Low Vision",
  "Pause Animations": "Animációk leállítása",
  "Reset all settings": "Beállítások visszaállítása",
  "Shortcut:": "Shortcut:"
}
